<template lang="html">
  <block-render :blocks="content" v-if="content"></block-render>
  <div class="" v-else="" style="height: 1000px;">
  </div>
</template>

<script>
// import BlockRender from '@/components/BlockRender'
import sanityQuery from '@/sanityQuery'

export default {
  data () {
    return {
      content: null
    }
  },
  metaInfo () {
    return {
      title: 'Rød Ungdom', // set a title
      htmlAttrs: {
        lang: 'no',
        amp: undefined // "amp" has no value
      },
      meta: [
        {name: 'title', content: 'Rød Ungdom'},
        {name: 'description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {name: 'twitter:title', content: 'Rød Ungdom'},
        {name: 'twitter:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {name: 'twitter:image', content: 'https://xn--rdt-0na.no/images/standard_delebilde_fb.png'},
        {property: 'og:title', content: 'Rød Ungdom'},
        {property: 'og:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'},
        {property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path}
      ]
    }
  },
  created () {
    const query = `*[_id == "489f4f54-e073-4896-af2b-1ee728ce3665" && !(_id in path "drafts.**")]
    {
      "blocks": blocks {
        "content": content[] {
          ...,
          "hero": hero {
            ...,
            "image": image {
              ...,
              "asset": asset->{url, metadata}
            }
          },
          "jerk": jerk {
            ...,
            "image": image {
              ...,
              "asset": asset->{url, metadata}
            }
          },
          "frontPageIssues": frontPageIssues[] {
            lead,
            "issue": frontPageIssue-> {
              title,
              slug,
              "image": image {
                ...,
                "asset": asset->{url, metadata}
              }
            }
          },
          "image": image{"asset": asset->{url, metadata}}
        }
      }
    }`

    sanityQuery(query)
      .then((result) => {
        this.content = result[0].blocks.content
      })
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/FrontPage.vue